import { render } from "./secure-manage.vue?vue&type=template&id=64cf4155&scoped=true"
import script from "./secure-manage.vue?vue&type=script&lang=js"
export * from "./secure-manage.vue?vue&type=script&lang=js"

import "./secure-manage.vue?vue&type=style&index=0&id=64cf4155&lang=css"
import "./secure-manage.vue?vue&type=style&index=1&id=64cf4155&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cf4155"]])

export default __exports__